import dwhExport from '~/dwhExport'
import { batchActions } from 'redux-batched-actions'
import get from 'lodash/get'
import mapKeys from 'lodash/mapKeys'
import { t } from '../helpers/localization'
import { getCurrentClan } from 'helpers/currentAccount'
import { snakeToCamel } from 'helpers/strings'
import { updateAccountInfo } from './ActionAccount'
import { updateBase, UpdateSupplyData } from './ActionSupply'
import { getFirstAssignableRole } from '../roles'
import * as web2ClientAPI from 'web2ClientAPI/web2ClientAPI'
import settings from '../settings'

import {
    setStatusUrlRenamingClan,
    startRenamingClan,
    stopRenamingClan,
    updateFieldValueRenamingClan,
} from './ActionClanRename'

import {
    fetchWithSpinner,
    fetchWrapper as fetch,
} from 'helpers/fetch'
import { getLastSeasonOfType } from 'helpers/ladder'
import { SEASON_TYPES } from 'reducers/ReducerClanBattles'
import { BATTLE_TYPES } from '../constants'

export const CLANS_CHANGE_TEAM_NUMBER = 'CLANS_CHANGE_TEAM_NUMBER'
export const CLANS_CHANGE_BATTLE_TYPE = 'CLANS_CHANGE_BATTLE_TYPE'
export const INCREASE_MAX_CLAN_SIZE = 'INCREASE_MAX_CLAN_SIZE'
export const CLEAR_MEMBERS_OPERATION = 'CLEAR_MEMBERS_OPERATION'
export const SELECT_ROLE_MEMBERS_OPERATION = 'SELECT_ROLE_MEMBERS_OPERATION'
export const START_UPDATE_MEMBERS = 'START_UPDATE_MEMBERS'
export const TOGGLE_ALL_MEMBERS_TICK = 'TOGGLE_ALL_MEMBERS_TICK'
export const TOGGLE_MEMBER_TICK = 'TOGGLE_MEMBER_TICK'
export const TOGGLE_MEMBERS_SORTING = 'TOGGLE_MEMBERS_SORTING'
export const UNTICK_CLAN_MEMBERS = 'UNTICK_CLAN_MEMBERS'
export const START_UPDATE_CLAN = 'START_UPDATE_CLAN'
export const UPDATE_CLAN = 'UPDATE_CLAN'
export const UPDATE_CLAN_FROM_SYNC = 'UPDATE_CLAN_FROM_SYNC'
export const UPDATE_MEMBERS = 'UPDATE_MEMBERS'
export const UPDATE_STATISTICS = 'UPDATE_STATISTICS'
export const DECREASE_CLAN_MEMBERS = 'DECREASE_CLAN_MEMBERS'
export const INCREASE_CLAN_MEMBERS = 'INCREASE_CLAN_MEMBERS'
export const DECREASE_CLAN_RESOURCE = 'DECREASE_CLAN_RESOURCE'
export const UPDATE_WOWS_LADDER = 'UPDATE_WOWS_LADDER'
export const UPDATE_ACHIEVEMENTS = 'UPDATE_ACHIEVEMENTS'
export const SET_CLAN_PROFILE_CURRENT_SEASON = 'SET_CLAN_PROFILE_CURRENT_SEASON'
export const SET_CLAN_PROFILE_CURRENT_SEASON_TYPE = 'SET_CLAN_PROFILE_CURRENT_SEASON_TYPE'


export const setClanProfileCurrentSeasonType = (currentSeasonType) => {
    return {
        type: SET_CLAN_PROFILE_CURRENT_SEASON_TYPE,
        currentSeasonType,
    }
}

export const setClanProfileCurrentSeason = (currentSeason) => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: SET_CLAN_PROFILE_CURRENT_SEASON,
        currentSeason,
    })
}

export const startUpdateClan = (clanId) => {
    return {
        type: START_UPDATE_CLAN,
        clanId,
    }
}

export const updateClan = (clan) => {
    return {
        type: UPDATE_CLAN,
        clan,
    }
}

export const updateClanFromSync = (clanId, clanInfo) => {
    return {
        type: UPDATE_CLAN_FROM_SYNC,
        clanId,
        clanInfo,
    }
}

export const increaseMaxClanSize = (clanId, extraMembers) => {
    return {
        type: INCREASE_MAX_CLAN_SIZE,
        clanId,
        extraMembers,
    }
}

export const setClanError = (clanId, error) => {
    return {
        type: UPDATE_CLAN,
        clan: {
            id: clanId,
            error,
        },
    }
}

export const decreaseClanMembersCount = (clanId, count) => {
    return {
        type: DECREASE_CLAN_MEMBERS,
        clanId,
        count,
    }
}

export const increaseClanMembersCount = (clanId, count) => {
    return {
        type: INCREASE_CLAN_MEMBERS,
        clanId,
        count,
    }
}

export const decreaseClanResource = (clanId, resource) => {
    return {
        type: DECREASE_CLAN_RESOURCE,
        clanId,
        resource,
    }
}

export const startUpdateMembers = (clanId) => {
    return {
        type: START_UPDATE_MEMBERS,
        clanId,
    }
}

export const updateMembers = (clanId, members) => {
    return {
        type: UPDATE_MEMBERS,
        members: members,
        isFetching: false,
        clanId: clanId,
        error: '',
    }
}

export const updateClanStatistics = (clanId, isHiddenStatistics, clanStatistics) => {
    return {
        type: UPDATE_STATISTICS,
        clanId,
        isHiddenStatistics,
        clanStatistics,
    }
}

export const setMembersError = (clanId, error) => {
    return {
        type: UPDATE_MEMBERS,
        members: [],
        isFetching: false,
        clanId: clanId,
        error: error,
    }
}

export const toggleMembersSorting = (clanId, field, isAsc, hiddenSortingNames) => {
    return {
        type: TOGGLE_MEMBERS_SORTING,
        clanId,
        isFetching: false,
        error: '',
        sort: {
            field,
            isAsc,
        },
        hiddenSortingNames,
    }
}

export const toggleMemberTick = (memberId) => {
    return {
        type: TOGGLE_MEMBER_TICK,
        memberId,
    }
}

export const toggleAllMembersTick = (memberIds) => {
    return {
        type: TOGGLE_ALL_MEMBERS_TICK,
        memberIds,
    }
}

export const clearMembersOperation = () => {
    return {
        type: CLEAR_MEMBERS_OPERATION,
    }
}

export const selectRoleMembersOperation = (roleName) => {
    return {
        type: SELECT_ROLE_MEMBERS_OPERATION,
        roleName,
    }
}

export const untickClanMembers = (memberIds) => {
    return {
        type: UNTICK_CLAN_MEMBERS,
        memberIds,
    }
}

export const updateWowsLadder = (clanId, wowsLadder) => {
    return {
        type: UPDATE_WOWS_LADDER,
        clanId,
        wowsLadder,
    }
}

export const updateAchievements = (clanId, achievements) => {
    return {
        type: UPDATE_ACHIEVEMENTS,
        clanId,
        achievements,
    }
}
const sendNotificationByClanOperationalError = (json, clan, members, sendErrorNotification) => {
    const additionalInfo = json.additional_info || {}
    const reason = additionalInfo.reason
    if (reason === 'insufficient_permissions') {
        if (additionalInfo.role) {
            sendErrorNotification('insufficient_permissions')
        } else {
            sendErrorNotification('excluded_from_clan', clan)
        }
    } else if (reason === 'members_not_in_clan') {
        const missingMemberIds = additionalInfo.ids
        const missingMembers = members.filter((member) => {
            return missingMemberIds.includes(member.id)
        })
        if (missingMembers.length > 0) {
            const missingMembersNames = missingMembers.map((member) => member.name)
            sendErrorNotification('members_not_in_clan', missingMembersNames, clan)
        } else {
            sendErrorNotification()
        }
    } else if (reason === 'role_rank_low') {
        const roles = additionalInfo.roles
        const newMembersInfo = []
        members.forEach((member) => {
            if (roles[member.id]) {
                newMembersInfo.push({
                    name: member.name,
                    roleName: roles[member.id],
                })
            }
        })
        sendErrorNotification('role_rank_low', newMembersInfo)
    } else {
        sendErrorNotification()
    }
}

export const removeMembers = (membersToRemoveIds) => {
    return (dispatch, getState) => {
        const state = getState()
        const clanId = state.currentAccount.clanId
        const members = state.members.clans[clanId].members
        const clan = state.clans.items[clanId]

        const removeMembersUrl = state.urls.removeMembers.replace('{clan_id}', clanId)
        const body = { user_ids: membersToRemoveIds }
        const options = {
            method: 'POST',
            body,
        }
        const removedMembers = members.filter((member) => membersToRemoveIds.includes(member.id))
        return fetch(removeMembersUrl, options)
            .then((json) => {
                if ('error' in json) {
                    sendNotificationByClanOperationalError(json, clan, removedMembers, web2ClientAPI.sendRemoveMembersErrorNotification)
                    throw json.error
                }
                const names = removedMembers.map((member) => member.name)
                web2ClientAPI.sendRemoveMembersNotification(names, clan)

                dispatch(batchActions([
                    untickClanMembers(membersToRemoveIds),
                    decreaseClanMembersCount(clanId, removedMembers.length),
                ]))
                return dispatch(fetchMembers(clanId))
            })
            .catch((e) => {
                if (typeof e === 'object') {
                    if (e.response && 'error' in e.response.body) {
                        const json = e.response.body
                        sendNotificationByClanOperationalError(json, clan, removedMembers, web2ClientAPI.sendRemoveMembersErrorNotification)
                        throw json.error
                    } else {
                        web2ClientAPI.sendRemoveMembersErrorNotification()
                        throw t('Техническая ошибка')
                    }
                }
                throw e
            })
    }
}

export const changeRole = (memberToChangeId) => {
    return (dispatch, getState) => {
        const state = getState()
        const clanId = state.currentAccount.clanId
        const changeRoleUrl = state.urls.changeRole.replace('{clan_id}', clanId)
        const memberIds = memberToChangeId ? [memberToChangeId] : state.membersOperation.selectedIds
        const roleName = state.membersOperation.selectedRole || getFirstAssignableRole(state.currentAccount.roleName)
        const body = { user_ids: memberIds, role: roleName }
        const options = {
            method: 'POST',
            body,
        }
        const clan = state.clans.items[clanId]
        const members = state.members.clans[clanId].members
        const newMembers = members.map((member) => {
            if (memberIds.indexOf(member.id) !== -1) {
                return Object.assign({}, member, {
                    roleName,
                })
            }
            return member
        })
        const membersToChange = members.filter((member) => memberIds.includes(member.id))

        return fetch(changeRoleUrl, options)
            .then((json) => {
                if ('error' in json && get(json, 'additional_info.reason') !== 'role_already_assigned') {
                    sendNotificationByClanOperationalError(json, clan, membersToChange, web2ClientAPI.sendChangeRoleErrorNotification)
                    throw json.error
                }
                const names = membersToChange.map((member) => member.name)
                web2ClientAPI.sendChangeRoleNotification({
                    names,
                    roleName,
                    clan,
                })

                dispatch(clearMembersOperation())
                dispatch(updateMembers(clanId, newMembers))
            })
            .catch((e) => {
                if (typeof e === 'object') {
                    if (e.response && 'error' in e.response.body) {
                        const json = e.response.body
                        sendNotificationByClanOperationalError(json, clan, membersToChange, web2ClientAPI.sendChangeRoleErrorNotification)
                        throw json.error
                    } else {
                        web2ClientAPI.sendChangeRoleErrorNotification()
                        throw t('Техническая ошибка')
                    }
                }
                throw e
            })
    }
}

export const changeCommander = (newCommander, isLeavingClan = false) => {
    return (dispatch, getState) => {
        const state = getState()
        const clanId = state.currentAccount.clanId
        const changeCommanderUrl = state.urls.changeCommander.replace('{clan_id}', clanId)
        const body = { user_id: newCommander }
        const options = {
            method: 'POST',
            body,
        }
        const currentAccountId = state.currentAccount.id
        const createNewMember = (member, roleName) => {
            return Object.assign({}, member, {
                roleName,
            })
        }
        const defaultRoleAfterCommander = 'executive_officer'
        const newMembers = state.members.clans[clanId].members.map((member) => {
            if (member.id === newCommander) {
                return createNewMember(member, 'commander')
            } else if (member.id === currentAccountId) {
                return createNewMember(member, defaultRoleAfterCommander)
            }
            return member
        })

        return fetch(changeCommanderUrl, options)
            .then((json) => {
                if ('error' in json) {
                    throw json
                }

                dispatch(clearMembersOperation())
                dispatch(updateAccountInfo({
                    role: defaultRoleAfterCommander,
                }))
                dispatch(updateMembers(clanId, newMembers))
                const member = newMembers.find((member) => member.id === newCommander)
                const currentClan = getCurrentClan(getState())
                web2ClientAPI.sendNewCommanderNotification(member, currentClan)
                web2ClientAPI.sendCurrentAccountTransferredLeadershipNotification(defaultRoleAfterCommander, currentClan)
                return true
            })
            .catch((json) => {
                const reason = get(json, 'additional_info.reason')
                if (reason === 'account_not_in_clan') {
                    const memberName = newMembers.find((member) => member.id === newCommander).name
                    const currentClan = getCurrentClan(getState())
                    web2ClientAPI.sendChangeCommanderErrorNotification(isLeavingClan, reason, memberName, currentClan)
                } else {
                    web2ClientAPI.sendChangeCommanderErrorNotification(isLeavingClan)
                }
                return false
            })
    }
}

export const changeClanBattleType = (clanId, battleType) => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: CLANS_CHANGE_BATTLE_TYPE,
        clanId,
        battleType,
    })
}

export const changeClanTeamNumber = (clanId, teamNumber) => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: CLANS_CHANGE_TEAM_NUMBER,
        clanId,
        teamNumber,
    })
}

const normalizeClan = (clan) => {
    const { created_at, raw_description, is_disbanded, accumulative_resource, personal_resource, max_members_count, ...others } = clan
    return {
        rawDescription: raw_description,
        createdAt: created_at,
        isDisbanded: is_disbanded,
        accumulativeResource: accumulative_resource,
        personalResource: personal_resource,
        maxMembersCount: max_members_count,
        ...others,
    }
}

export const fetchClan = (clanId, withGlobalSpinner = true, updateByWrongResult = true) => {
    return (dispatch, getState) => {
        dispatch(startUpdateClan(clanId))

        const clanInfoUrl = getState().urls.clanInfo.replace('{clan_id}', clanId)
        const promise = fetch(clanInfoUrl)
            .then((json) => {
                if ('error' in json) {
                    throw json.error
                }

                let clan = json.clanview.clan
                if (!clan) {
                    throw t('Произошла ошибка. Повторите попытку позже')
                }
                clan = normalizeClan(clan)

                const state = getState()
                const wowsLadder = json.clanview.wows_ladder
                const renamingInfo = json.clanview.renaming_info
                let actions = [updateClan(clan)]
                if (json.clanview.buildings || updateByWrongResult) {
                    actions = [
                        ...actions,
                        updateBase(clanId, json.clanview.buildings),
                    ]
                    dispatch(UpdateSupplyData(clanId, json.clanview.buildings))
                }

                if (wowsLadder || updateByWrongResult) {
                    actions = [
                        ...actions,
                        updateWowsLadder(clanId, wowsLadder),
                    ]
                }

                if (json.clanview.achievements || updateByWrongResult) {
                    actions = [
                        ...actions,
                        updateAchievements(clanId, json.clanview.achievements),
                    ]
                }

                if (renamingInfo) {
                    actions = [
                        startRenamingClan(),
                        setStatusUrlRenamingClan(renamingInfo.status_url),
                        updateFieldValueRenamingClan('tag', renamingInfo.tag, null),
                        updateFieldValueRenamingClan('name', renamingInfo.name, null),
                        ...actions,
                    ]
                } else if (state.clanRename.isProcessing) {
                    actions = [
                        stopRenamingClan(),
                        ...actions,
                    ]
                }

                return dispatch(batchActions(actions))
            })
            .catch((e) => {
                if (!updateByWrongResult) return

                const message = typeof e === 'object' ? t('Произошла ошибка. Повторите попытку позже') : e
                dispatch(batchActions([
                    setClanError(clanId, message),
                    updateBase(clanId),
                ]))
            })
        return withGlobalSpinner ? fetchWithSpinner(dispatch, promise) : promise
    }
}

const normalizeMembers = (members) => members.map((member) => mapKeys(member, (value, key) => snakeToCamel(key)))

const applyCustomizedRole = (members) => {
    members.forEach((member) => {
        member.roleName = member.role.name
        delete member.role
    })
}

export const fetchMembers = (clanId, withGlobalSpinner = false, battleType = null) => {
    return (dispatch, getState) => {
        const state = getState()
        const teamNumber = state.members.teamNumber[clanId]
        if (state.members.isFetching[clanId]) {
            return
        }

        dispatch(startUpdateMembers(clanId))

        let fetchMembersUrl = state.urls.fetchMembers
            .replace('{clan_id}', clanId)
            .replace('{battle_type}', state.members.battleTypes[clanId] || settings.defaultBattleType)

        if (battleType) {
            fetchMembersUrl = state.urls.fetchMembers
                .replace('{clan_id}', clanId)
                .replace('{battle_type}', battleType)
        }

        const isCVCRegular = state.members.battleTypes[clanId] === BATTLE_TYPES.REGULAR_CVC || battleType === BATTLE_TYPES.REGULAR_CVC
        const isCVCBrawl = state.members.battleTypes[clanId] === BATTLE_TYPES.BRAWL_CVC || battleType === BATTLE_TYPES.BRAWL_CVC
        const isCVCAny = battleType === 'cvc_or_brawl'

        if (isCVCRegular || isCVCBrawl) {
            let season = state.members.currentSeason
            const seasonType = isCVCRegular ? SEASON_TYPES.REGULAR : SEASON_TYPES.BRAWL

            if (state.members.currentSeasonType !== seasonType) {
                dispatch(setClanProfileCurrentSeasonType(seasonType))
                season = getLastSeasonOfType(seasonType).id
                dispatch(setClanProfileCurrentSeason(season))
            }

            fetchMembersUrl = state.urls.fetchMembers
                .replace('{clan_id}', clanId)
                .replace('{battle_type}', 'cvc') + '&season=' + season
            
            if (teamNumber && isCVCRegular) {
                fetchMembersUrl = fetchMembersUrl + '&team_number=' + teamNumber
            }
        }

        if (isCVCAny) {
            const season = state.members.currentSeason
            fetchMembersUrl = state.urls.fetchMembers
                .replace('{clan_id}', clanId)
                .replace('{battle_type}', 'cvc') 
            fetchMembersUrl = season ? fetchMembersUrl + '&season=' + season : fetchMembersUrl
        }

        const promise = fetch(fetchMembersUrl)
            .then((json) => {
                if (json.status !== 'ok') {
                    dispatch(setMembersError(clanId, json.error))
                    return
                }

                const isHiddenStatistics = json.is_hidden_statistics
                const clanStatistics = json.clan_statistics
                const members = normalizeMembers(json.items)
                applyCustomizedRole(members)
                dispatch(batchActions([
                    updateClanStatistics(clanId, isHiddenStatistics, clanStatistics),
                    updateMembers(clanId, members),
                ]))
            })
            .catch(() => {
                dispatch(batchActions([
                    setMembersError(clanId, t('Произошла ошибка. Повторите попытку позже')),
                    updateClanStatistics(clanId, false, null),
                ]))
            })

        return withGlobalSpinner ? fetchWithSpinner(dispatch, promise) : promise
    }
}


export const OPEN_CLAN_DESCRIPTION_DIALOG = 'OPEN_CLAN_DESCRIPTION_DIALOG'
export const openClanDescriptionDialog = () => {
    return {
        type: OPEN_CLAN_DESCRIPTION_DIALOG,
    }
}

export const CLOSE_CLAN_DESCRIPTION_DIALOG = 'CLOSE_CLAN_DESCRIPTION_DIALOG'
export const closeClanDescriptionDialog = () => {
    return {
        type: CLOSE_CLAN_DESCRIPTION_DIALOG,
    }
}


export const OPEN_CLAN_DESCRIPTION_EDIT_DIALOG = 'OPEN_CLAN_DESCRIPTION_EDIT_DIALOG'
export const openClanDescriptionEditDialog = () => {
    return {
        type: OPEN_CLAN_DESCRIPTION_EDIT_DIALOG,
    }
}

export const CLOSE_CLAN_DESCRIPTION_EDIT_DIALOG = 'CLOSE_CLAN_DESCRIPTION_EDIT_DIALOG'
export const closeClanDescriptionEditDialog = () => {
    return {
        type: CLOSE_CLAN_DESCRIPTION_EDIT_DIALOG,
    }
}

export const OPEN_CLAN_NAME_EDIT_DIALOG = 'OPEN_CLAN_NAME_EDIT_DIALOG'
export const openClanNameEditDialog = () => {
    return {
        type: OPEN_CLAN_NAME_EDIT_DIALOG,
    }
}

export const CLOSE_CLAN_NAME_EDIT_DIALOG = 'CLOSE_CLAN_NAME_EDIT_DIALOG'
export const closeClanNameEditDialog = () => {
    return {
        type: CLOSE_CLAN_NAME_EDIT_DIALOG,
    }
}

export const OPEN_CLAN_RULES_DIALOG = 'OPEN_CLAN_RULES_DIALOG'
export const openClanRulesDialog = () => (dispatch: Dispatch, getState: GetState) => {
    dwhExport.send('supply.view_rules')
    dispatch({
        type: OPEN_CLAN_RULES_DIALOG,
    })
}

export const CLOSE_CLAN_RULES_DIALOG = 'CLOSE_CLAN_RULES_DIALOG'
export const closeClanRulesDialog = () => {
    return {
        type: CLOSE_CLAN_RULES_DIALOG,
    }
}

export const OPEN_OLD_RECOMMENDATIONS_DIALOG = 'OPEN_OLD_RECOMMENDATIONS_DIALOG'
export const openOldRecommendationsDialog = () => {
    return {
        type: OPEN_OLD_RECOMMENDATIONS_DIALOG,
    }
}

export const CLOSE_OLD_RECOMMENDATIONS_DIALOG = 'CLOSE_OLD_RECOMMENDATIONS_DIALOG'
export const closeOldRecommendationsDialog = () => {
    return {
        type: CLOSE_OLD_RECOMMENDATIONS_DIALOG,
    }
}

export const OPEN_RECOMMENDATIONS_DIALOG = 'OPEN_RECOMMENDATIONS_DIALOG'
export const openRecommendationsDialog = () => {
    return {
        type: OPEN_RECOMMENDATIONS_DIALOG,
    }
}

export const CLOSE_RECOMMENDATIONS_DIALOG = 'CLOSE_RECOMMENDATIONS_DIALOG'
export const closeRecommendationsDialog = () => {
    return {
        type: CLOSE_RECOMMENDATIONS_DIALOG,
    }
}

export const OPEN_LEAVE_DIALOG = 'OPEN_LEAVE_DIALOG'
export const openLeaveDialog = () => {
    return {
        type: OPEN_LEAVE_DIALOG,
    }
}

export const CLOSE_LEAVE_DIALOG = 'CLOSE_LEAVE_DIALOG'
export const closeLeaveDialog = () => {
    return {
        type: CLOSE_LEAVE_DIALOG,
    }
}